import React, { useState } from "react";
import styles from "./setting.module.css";
import {
  FaChevronRight,
} from "react-icons/fa";
import { Modal, TextComponent } from "../../components";
import DiscountManagement from "./DiscountManagement/DiscountManagement";
import AdsPricing from "./AdsPricing/AdsPricing";
import Passwordmanagment from "./Passwordmanagment/Passwordmanagment";

const tabs = [
  {
    id: "discount",
    label: "Discount Management",
    Component: <DiscountManagement />,
  },
 {
    id: "pricing",
    label: "Ads Pricing",
    Component: <AdsPricing />,
  },
  {
    id: "password",
    label: "Password Management",
    Component: <Passwordmanagment />,
  },
];

const Setting = () => {
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <div className={styles.settingsContainer}>
      <div className={styles.sidebar}>
        <TextComponent text="Settings" className={styles.heading} />
        {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`${activeTab.id === tab.id ? styles.tab : styles.tabx}`}
              onClick={() => setActiveTab(tab)} 
            >
              <TextComponent
                className={`${
                  activeTab.id === tab.id
                    ? styles.ActivetabLabel
                    : styles.tabLabel
                }`}
              >
                {tab.icon && <span className={styles.icon}>{tab.icon}</span>}{" "}
                {tab.label}
              </TextComponent>
                <FaChevronRight className={styles.rightIcon} />
            </button>
          )
        )}
      </div>
      <div className={styles.content}>
        {activeTab.Component ? activeTab.Component : <p>Select an option</p>}
      </div>
    </div>
  );
};
export default Setting;